<script>
  import { onMount } from "svelte";
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function close(cookie = true) {
    const cookies = document.querySelector(".cookies-container");
    cookies.style.opacity = 0;
    setCookie("cookies", cookie, 14);

    setTimeout(() => {
      cookies.style.display = "none";
    }, 250);
  }

  function disableGa() {
    window["ga-disable-G-ECBKM1KNZE"] = true;
    close(false);
  }

  onMount(() => {
    const cookie = getCookie("cookies");
    if (cookie === null) {
      document.querySelector(".cookies-container").style.display = "block";
    } else {
      if (cookie === false) {
        window["ga-disable-G-ECBKM1KNZE"] = true;
      }
    }
  });
</script>

<div class="cookies-container container-fluid pb-5 pt-3">
  <div class="col-1 offset-11 mb-3">
    <i class="ci-close_big close" on:click={close} />
  </div>
  <div class="container">
    <div class="d-flex">
      <i class="ci-cookie ms--md-4 cookie" />

      <div class="col-12 col-md-8">
        <h1 class="col-12 ms-md-4">Hej! Nasza strona używa ciasteczek.</h1>
        <p class="col-12 col-md-8 ms-md-4 pe-4">
          Ta strona korzysta z ciasteczek aby świadczyć usługi na najwyższym
          poziomie. Dalsze korzystanie ze strony oznacza, że zgadzasz się na ich
          użycie. Wykorzystujemy je wraz z innymi technologiami, aby zapewnić
          prawidłowe działanie strony oraz analizować w jaki sposób przeglądasz
          stronę. Z powyższych powodów możemy udostępniać Twoje dane
          przeglądania strony usługom zewnętrznym.
        </p>
        <div class="col-12 col-md-10 ms-md-2 row">
          <div class="col-6">
            <button class="col-12 btn--outline" on:click={disableGa}
              >ODRZUĆ</button
            >
          </div>

          <div class="col-6">
            <button class="col-12 btn--fill" on:click={close}>AKCEPTUJ</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .cookies-container {
    display: none;
    position: fixed;
    bottom: 0;
    z-index: 69;
    background-color: white;
    box-shadow: 0px -4px 14px 1px rgba(0, 0, 0, 0.1);
    transition: opacity 0.25s ease-in-out;
  }

  h1 {
    font-family: Work Sans;
    font-weight: 700;
    font-size: 18px;
  }

  p {
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
  }

  .close {
    font-size: 22px;
    background-color: #fdcd18;
    padding: 3px;
    border-radius: 3px;
    cursor: pointer;
  }

  .cookie {
    font-size: 48px;
  }

  .btn--fill {
    background-color: #fdcd18;
    outline: none;
    border: none;
    padding: 15px 0px;
    font-family: "Montserrat";
    font-weight: bold;
    font-size: 13px;
    text-decoration: none;
    color: #425466;
  }

  .btn--outline {
    border: 2px solid #fdcd18;
    background-color: white;
    padding: 13px 0px;
    font-family: "Montserrat";
    font-weight: bold;
    font-size: 13px;
    text-decoration: none;
    color: #425466;
  }

  @media only screen and (max-width: 576px) {
    .cookie {
      font-size: 22px;
      padding-right: 10px;
    }

    h1 {
      font-size: 16px;
    }

    p {
      font-size: 12px;
    }
  }
</style>
